import type { ComponentChildren } from 'preact'

interface Props {
  title: string
  description?: ComponentChildren
  children?: ComponentChildren
}

export function Panel({ title, description, children }: Props) {
  return (
    <section class="panel">
      <h2>{title}</h2>
      {description !== undefined && <p class="panel-desc">{description}</p>}
      {children}
    </section>
  )
}
